import { RootState } from "../../store";
import { getAskAiChatIdSelector } from "@/store/ask-ai/selectors/getAskAiChatIdSelector";

export const askAiChatIdSelector = (state: RootState) => {
  return getAskAiChatIdSelector(state)?.data?.chat_id;
};
